import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import Page from 'flarum/common/components/Page';
import Link from 'flarum/common/components/Link';
import Button from 'flarum/common/components/Button';
import app from 'flarum/forum/app';
import Stream from 'flarum/common/utils/Stream';
import NagusiBackNav from '../common/NagusiBackNav';
import HelpData from '../HelpData';
import NotificationWizardModal from './NotificationWizardModal';
export default class HelpIndexPage extends Page {
  oninit(vnode) {
    super.oninit(vnode);
    this.searchQuery = Stream('');
    const normalize = text => (text || '').toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/\s+/g, ' ').trim();

    // Pre-index normalized text for search performance
    this.indexedSections = HelpData().map(section => _objectSpread(_objectSpread({}, section), {}, {
      searchIndex: normalize(section.title + ' ' + section.description + ' ' + (section.keywords || '') + ' ' + (section.fullText || ''))
    }));
  }
  view() {
    const query = (this.searchQuery() || '').toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").trim();
    const queryWords = query.split(' ').filter(w => w.length > 0);
    const filteredSections = this.indexedSections.filter(section => {
      if (queryWords.length === 0) return true;
      // All words in query must be present in the search index
      return queryWords.every(word => section.searchIndex.includes(word));
    });
    return m("div", {
      className: "HelpPage HelpIndexPage"
    }, m("div", {
      className: "container"
    }, m(NagusiBackNav, {
      title: "Centro de Ayuda"
    }), m("div", {
      className: "HelpHeader"
    }, m("h1", null, m("i", {
      className: "fas fa-question-circle"
    }), " Centro de Ayuda"), m("p", null, "\xBFEn qu\xE9 podemos ayudarte hoy? Busca entre nuestros tutoriales y gu\xEDas."), m("div", {
      className: "HelpSearch"
    }, m("i", {
      className: "fas fa-search SearchIcon"
    }), m("input", {
      type: "text",
      className: "FormControl",
      placeholder: "Buscar dudas (ej: instalar app, puntos...)",
      oninput: e => this.searchQuery(e.target.value),
      value: this.searchQuery()
    }))), m("div", {
      className: "HelpWizardHero",
      style: "background: linear-gradient(135deg, rgba(238, 37, 35, 0.08) 0%, rgba(16, 185, 129, 0.08) 100%); border: 1.5px solid rgba(238, 37, 35, 0.25); border-radius: 14px; padding: 18px 22px; margin-bottom: 25px; display: flex; align-items: center; justify-content: space-between; gap: 16px; flex-wrap: wrap;"
    }, m("div", {
      style: "display: flex; align-items: center; gap: 14px; flex: 1; min-width: 260px;"
    }, m("span", {
      style: "font-size: 2.2em; line-height: 1;"
    }, "\uD83E\uDD81"), m("div", null, m("strong", {
      style: "font-size: 1.1em; display: block; color: var(--text-color); margin-bottom: 2px;"
    }, app.translator.trans('nagusi-tutorials.forum.notifications_wizard.hero_title') || 'Asistente de Notificaciones'), m("p", {
      style: "margin: 0; font-size: 0.9em; color: var(--muted-control-color); line-height: 1.35;"
    }, app.translator.trans('nagusi-tutorials.forum.notifications_wizard.hero_desc') || '¿No sabes cómo configurar tus alertas? Configúralas en 30 segundos con nuestro configurador interactivo.'))), m(Button, {
      className: "Button Button--primary",
      style: "border-radius: 20px; font-weight: 700; white-space: nowrap; background: #ee2523; border-color: #ee2523; padding: 10px 20px;",
      icon: "fas fa-magic",
      onclick: () => app.modal.show(NotificationWizardModal)
    }, app.translator.trans('nagusi-tutorials.forum.notifications_wizard.open_wizard') || 'Abrir Asistente')), m("div", {
      className: "HelpGrid"
    }, filteredSections.length > 0 ? filteredSections.map(section => m(Link, {
      href: app.route('nagusi.tutorials.ayuda.section', {
        slug: section.slug
      }),
      className: "HelpCard"
    }, m("div", {
      className: "HelpCard-icon"
    }, m("i", {
      className: section.icon
    })), m("div", {
      className: "HelpCard-content"
    }, m("h3", null, section.title), m("p", null, section.description)), m("div", {
      className: "HelpCard-arrow"
    }, m("i", {
      className: "fas fa-chevron-right"
    })))) : m("div", {
      className: "HelpNoResults"
    }, m("i", {
      className: "fas fa-search-minus"
    }), m("p", null, "No hemos encontrado nada que coincida con \"", m("strong", null, this.searchQuery()), "\""), m("button", {
      className: "Button Button--link",
      onclick: () => this.searchQuery('')
    }, "Ver todos los temas de ayuda")))));
  }
}
flarum.reg.add('nagusi-match-ratings', 'forum/tutorials/HelpIndexPage', HelpIndexPage);